import React from 'react';
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer } from 'recharts';

const RevenueBreakdownChart = ({ data }) => {
  return (
    <div className="card">
      <h3 className="text-xl font-heading font-semibold text-foreground mb-6">
        Revenue Breakdown by Service
      </h3>
      <div className="w-full h-80" aria-label="Revenue Breakdown Bar Chart">
        <ResponsiveContainer width="100%" height="100%">
          <BarChart data={data} margin={{ top: 5, right: 30, left: 20, bottom: 5 }}>
            <CartesianGrid strokeDasharray="3 3" stroke="var(--color-border)" />
            <XAxis 
              dataKey="service" 
              stroke="var(--color-muted-foreground)"
              style={{ fontSize: '14px' }}
            />
            <YAxis 
              stroke="var(--color-muted-foreground)"
              style={{ fontSize: '14px' }}
            />
            <Tooltip 
              contentStyle={{ 
                backgroundColor: 'var(--color-card)',
                border: '1px solid var(--color-border)',
                borderRadius: '12px',
                padding: '12px'
              }}
              formatter={(value) => `$${value?.toLocaleString()}`}
            />
            <Legend 
              wrapperStyle={{ paddingTop: '20px' }}
              iconType="circle"
            />
            <Bar 
              dataKey="revenue" 
              fill="var(--color-primary)" 
              radius={[8, 8, 0, 0]}
              name="Revenue ($)"
            />
          </BarChart>
        </ResponsiveContainer>
      </div>
    </div>
  );
};

export default RevenueBreakdownChart;